export const BREAKPOINT = {
  ZERO: 'zero',
  XSMALL: 'xsmall',
  SMALL: 'small',
  MEDIUM: 'medium',
  XMEDIUM: 'xmedium',
  LARGE: 'large',
  XLARGE: 'xlarge',
  XXLARGE: 'xxlarge',
  XXXLARGE: 'xxxlarge',
  XXXXLARGE: 'xxxxlarge',
  XXXXXLARGE: 'xxxxxlarge',
} as const

export const VIEWPORT = {
  MOBILE: 'mobile',
  DESKTOP: 'desktop',
} as const

export const breakpoints = Object.values(BREAKPOINT)
